module.exports = __webpack_public_path__ + "img/good-4.1998690b.png";